<template>
	<DataTableRepresentation
		v-if="!isNoResults"
		canChooseItems
		isTableFocused
		v-on="$listeners"
		:listKey="resultsKey"
		:input="filteredItems"
		:searchString="searchString"
		class="input-item-container"
		ref="data_table_representation"
		:overrideTableTitle="overrideTableTitle"
	/>
	<NoDataFoundMessage v-else />
</template>
<script>
const RESULTS_KEY = 'results';
import isEmpty from 'lodash/isEmpty';
import { cloneDeep } from 'lodash';
import NoDataFoundMessage from '@/components/DataInput/DataInputMenu/NoDataFoundMessage';
import DataTableRepresentation from '@/components/DataTableRepresentation/DataTableRepresentation';
export default {
	name: 'DataTableColumnSelectionHandler',
	props: {
		searchString: { type: String },
		overrideTableTitle: { type: String },
		fieldParams: { type: [Array, Object, String, Number] },
	},
	components: {
		NoDataFoundMessage,
		DataTableRepresentation,
	},
	computed: {
		resultsKey() {
			return RESULTS_KEY;
		},
		filteredItems() {
			if (!this.searchString || this.searchString.length === 0) {
				return this.fieldParams;
			}
			const res = [];
			const clonedFieldParams = cloneDeep(this.fieldParams);
			clonedFieldParams?.map((allColumns) => {
				const allKeys = Object.keys(allColumns);
				allKeys.map((key) => {
					if (!key.toLowerCase().includes(this.searchString.toLowerCase())) {
						delete allColumns[key];
					}
				});
				res.push(allColumns);
			});
			return res;
		},
		isNoResults() {
			if (isEmpty(this.fieldParams)) {
				return true;
			}
			return this.filteredItems.some((page) => Object.keys(page).length === 0);
		},
	},
	methods: {
		unExpandItem() {
			this.$emit('un-expand-table-column-options');
		},
		focusOnNextMenuItem() {
			this.$refs.data_table_representation.focusOnNextMenuItem();
		},
		focusOnPreviousMenuItem() {
			this.$refs.data_table_representation.focusOnPreviousMenuItem();
		},
		selectFocusedItem() {
			this.$refs.data_table_representation.selectFocusedItemWithEnter();
		},
		itemClick(val) {
			this.$emit('item-clicked', { value: val, index: this.idx });
		},
		showDataTableItem(value, key) {
			if (!this.searchString || this.searchString.length === 0) {
				return true;
			}
			return (
				key?.toString().toLowerCase().includes(this.searchString.toLowerCase()) ||
				value?.toString().toLowerCase().includes(this.searchString.toLowerCase())
			);
		},
	},
};
</script>
<style lang="scss">
.input-item-container {
	font-size: 12px;
	padding: 0px 6px;
}
</style>
